module.exports = __webpack_public_path__ + "static/img/334.ffa091d1.jpg";